import React, { Component } from 'react';
import './CustomReport.css';
import Page from '../../components/page/Page';
import ReportContent from '../../components/reportContent/ReportContent';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import CreateCustomReportPopup from '../../popups/createCustomReportPopup/CreateCustomReportPopup';
import ReportTypes from '../../components/reportContent/reports.js';
import models from '../../model/models';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import toasts from '../../utils/toasts';
import SecondaryButton from '../../components/secondaryButton/SecondaryButton';
import utils from '../../utils/utils';
import cloneDeep from 'lodash.clonedeep';
import ReportTooLargeWarning from "./ReportTooLargeWarning";
import mainAPI from "../../api/MainAPI";

export default class CustomReport extends Component {
	constructor(props) {
		super(props);
		this.state = {
			exportCsv: false,
			exportPdf: false,
			displayTooLargeWarning: false,
      user_group_id: localStorage.user_group_id
		};
	}

	componentDidMount = () => {
		this.subscribeId = models.report.onChange(this._getData);
		this._getData();
		this.setState({ displayTooLargeWarning: !this.browserSupported() });
	};

	componentWillUnmount = () => {
		models.report.unsubscribe(this.subscribeId);
	};

	_getData = () => {
		let reportName = this.props.match.params.reportname;
		let id = this.props.match.params.id;
		let report = null;
		let fields = null;
		if (reportName === 'custom') {
			report = models.report.obj(id);
		} else {
			fields = ReportTypes[reportName];
			const reportType = reportName.toLowerCase().replace(/ /g, '_')
			if (!fields) {
				fields = cloneDeep(ReportTypes.fentanyl);
				fields.endpointFilters = {type:{values:[reportType]}};
			}
			report = { fields };
		}
		this.setUserGroup().catch(console.error);
		this.setState({ report });
	};

	setUserGroup = async () => {
		const [userGroup] = await mainAPI.user_group.current() || [{}];
	  this.setState({userGroup});
	};

	_startDateChanged = (value) => {
		this.setState({ startDate: value });
		console.log('start Date Changed', value);
	};

	_endDateChanged = (value) => {
		this.setState({ endDate: value });
		console.log('end Date Changed', value);
	};

	_startDate = () => {
		if (!this.state.startDate) {
			return null;
		}
		try {
			return new Date(this.state.startDate).getTime();
		} catch (e) {
			console.log(e);
			return null;
		}
	};

	_endDate = () => {
		if (!this.state.endDate) {
			return null;
		}
		try {
			return new Date(this.state.endDate).getTime();
		} catch (e) {
			console.log(e);
			return null;
		}
	};

	_exportExcel = () => {
		let {  columns, dataUrl } = this.reportContent.getExportData();
		downloadFilePost([], this._reportName(), columns, '/api/v1/report/excel', dataUrl);
	};

	_exportPdf = () => {
		let { columns, dataUrl } = this.reportContent.getExportData();

		downloadFilePost([], this._reportName(), columns, '/api/v1/report/pdf', dataUrl);
	};

	_exportCsv = () => {
		let { columns, dataUrl } = this.reportContent.getExportData();
		if (dataUrl) {
			toasts.show('Large exports can take up to 30 seconds', 5000);
			return downloadFilePost([], this._reportName(), columns, '/api/v1/report/csv', dataUrl);
		}
	};

	_promptSaveAsNewReport = () => {
		let fields = this.reportContent.getFields();
		window.popupController.show(CreateCustomReportPopup, {
			fields, onClose: ({created} = {created: false}) => {
				if (created) toasts.show('New custom report saved');
				window.popupController.hide(CreateCustomReportPopup, {})
			}
		});
	};

	_saveReport = async () => {
		let fields = this.reportContent.getFields();
		let report = { id: this.props.match.params.id, fields };
		let success = await models.report.save(report);
		if (!success) return toasts.show('Something went wrong');
		toasts.show('Saved');
	};

	exportEnabled = () => {
		const user_group = this.state.userGroup;
		if (user_group && user_group.has_overdue_invoice) return false;
		return true;
	}
	browserSupported = () => {
		if (!this.reportContent) return true;
		return !this.reportContent.browserRenderingNotAllowed();
	};

	_reportName = () => {
		if (this.state.report && this.state.report.name) return this.state.report.name;
		return this.props.match.params.reportname.replaceAll('_', ' ').replaceAll('-', ' ');
	};

	_renderSaveButton = () => {
		if (this.props.match.params.reportname !== 'custom') return;
		return <PrimaryButton onClick={this._saveReport}>Save</PrimaryButton>;
	};

	render() {
		return (
			<Page className="g-custom-report">
				<Card>
					<div className="top-row">
						<Label black large className="title">
							{this._reportName()}
						</Label>
						{/*<Input value={this.state.startDate} onChange={this._startDateChanged} type='date'/>*/}
						{/*<Label className='date-separator'>to</Label>*/}
						{/*<Input value={this.state.endDate} onChange={this._endDateChanged} type='date'/>*/}

						{this.exportEnabled() && this.browserSupported() && <SecondaryButton onClick={this._exportExcel}>Export Excel</SecondaryButton>}
						{this.exportEnabled() && this.browserSupported() && <PrimaryButton onClick={this._exportPdf}>Export PDF</PrimaryButton>}
            {this.exportEnabled() &&<SecondaryButton onClick={this._exportCsv}>Export CSV</SecondaryButton>}
						{this._renderSaveButton()}
						{this.exportEnabled() && this.browserSupported() && (
							<PrimaryButton onClick={this._promptSaveAsNewReport}>Save as New Report</PrimaryButton>
						)}
					</div>
					<ReportTooLargeWarning display={this.state.displayTooLargeWarning} />
					<ReportContent
						ref={(ref) => (this.reportContent = ref)}
						exportCsv={this.state.exportCsv}
						exportPdf={this.state.exportPdf}
						startDate={this._startDate()}
						reportName={this._reportName()}
						endDate={this._endDate()}
						report={this.state.report}
						reportType={this.props.match.params.reportname}
						itemId={this.props.match.params.id}
					/>
				</Card>
				<iframe name="FileDownloadIframe" id="FileDownloadIframe" src="about:blank" />
			</Page>
		);
	}
}

export function downloadFilePost(objData, reportName, columns, endpoint, dataUrl) {
	let strAction = endpoint;
	let strWindowName = 'FileDownloadIframe'; // ifrmDownload

	let formToDelete = document.getElementById('PdfFormId');
	if (formToDelete) {
		formToDelete.remove();
	}

	let form = document.createElement('form');
	form.setAttribute('id', 'PdfFormId');
	form.setAttribute('method', 'post');
	form.setAttribute('action', strAction);
	form.setAttribute('target', strWindowName);
	form.setAttribute('style', 'display: none;');

	// Prepare data fields
	const data = {
		// data: JSON.stringify(objData),
		name: reportName,
		token: localStorage.token,
		last_log_in: localStorage.last_log_in,
		user_group_id: localStorage.user_group_id,
		dataUrl,
		region: localStorage.region,
		columns: JSON.stringify(columns),
		date: utils.display_actual_datetime(new Date()),
		timezoneOffset: new Date().getTimezoneOffset() / 60
	};

	for (const key in data) {
		if (!data[key]) continue;
		let hiddenField = document.createElement('input');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', data[key]);
		form.appendChild(hiddenField);
	}

	document.body.appendChild(form);

	// Submit the form without opening a new tab
	form.submit();
	setTimeout(() => {
		let formToDelete = document.getElementById('PdfFormId');
		if (formToDelete) {
			formToDelete.remove();
		}
	}, 3000);
}



// WEBPACK FOOTER //
// ./src/pages/customReport/CustomReport.jsx